import { createAsyncThunk } from '@reduxjs/toolkit';
import ImportDataManager from '../services/import-data-manager';
import { importStarted, importSuccess, importFailure, clearImportData } from '../reducers/admin-reducer';

interface ImportError {
  message?: string;
}

export const importDataAsync = createAsyncThunk<unknown, unknown[], { rejectValue: string }>(
  'admin/importDataAsync',
  async (importData, { rejectWithValue }) => {
    try {
      const importManager = new ImportDataManager();
      const result = await importManager.publishImportData(importData as Record<string, string>[]);
      return result;
    } catch (err) {
      const error = err as ImportError;
      return rejectWithValue(error.message || 'Import failed');
    }
  },
);

export const importStashersAsync = createAsyncThunk<unknown, unknown[], { rejectValue: string }>(
  'admin/importStashersAsync',
  async (stashersData, { rejectWithValue }) => {
    try {
      const importManager = new ImportDataManager();
      const result = await importManager.publishImportStashersData(
        stashersData as unknown as Array<{ firstName: string | null; lastName: string | null; email?: string | null; mobilePhone?: string | null }>,
      );
      return result;
    } catch (err) {
      const error = err as ImportError;
      return rejectWithValue(error.message || 'Stashers import failed');
    }
  },
);

export { importStarted, importSuccess, importFailure, clearImportData };
